import React, { useEffect, useState, useRef } from "react";
import AuditSelect from './AuditSelect';
import { useGetUserCompanies } from "../../backend/query";
import { useHistory } from "raviger";
import { sortBy } from "underscore";
import { getUserDetails } from "../../backend/auth";


const INCLUDE_USER_COMPANY_ASSOCIATIONS = {
  parent_company: {
    associate_companies: {
      company_location_mappings: {
        location: ['city']
      }
    }
  }
};

const ALL_OPTION = {
  value: "all",
  label: "All"
};

function Location({ onChange, previousFilters }: any) {
    const { state }: any = useHistory();
    const [companies, setCompanies] = useState<any[]>([]);
    const [associateCompanies, setAssociateCompanies] = useState<any[]>([]);
    const [locations, setLocations] = useState<any[]>([]);
    const [company, setCompany] = useState<any>(ALL_OPTION);
    const [associate_company, setAssociateCompany] = useState<any>(ALL_OPTION);
    const [location, setLocation] = useState<any>(ALL_OPTION);
    const initialLoadComplete = useRef(false);
    const user = getUserDetails();

    const { userCompanies, isFetching }: any = useGetUserCompanies({
      filters: {
        users_id_eq: user.user_id,
        is_active_eq: true
      },
      includes: INCLUDE_USER_COMPANY_ASSOCIATIONS,
    });

    useEffect(() => {
        setAssociateCompany(ALL_OPTION);
        setLocations([]);
        setLocation(ALL_OPTION);

        if (company && company.value !== "all") {
            const associateCompanies = (company.company.associate_companies || []).map((associate_company: any) => {
                return {
                    label: associate_company.name,
                    value: associate_company.id,
                    associate_company: associate_company,
                    locations: associate_company.locations
                };
            });
            const sorted: any[] = sortBy(associateCompanies, 'label');
            setAssociateCompanies(sorted);
        } else {
            setAssociateCompanies([]);
        }
    }, [company]);

    useEffect(() => {
        setLocations([]);
        setLocation(ALL_OPTION);

        if (associate_company && associate_company.value !== "all" && company && company.value !== "all") {
            const locations = (associate_company.locations || []).map((location: any) => {
                return { label: `${location.name}, ${location.city.name}`, value: location.id, location, state_id: location.state.id };
            });
            const sorted = sortBy(locations, 'label');
            setLocations(sorted);
        }
    }, [associate_company]);

    useEffect(() => {
        if (companies && companies.length > 0 && !isFetching && Object.keys(previousFilters || {}).length) {
            const _company = companies.find((c: any) => c.value === ((previousFilters || {}).company || {}).value);
            if (_company) {
                setCompany(_company);
            }
        }
    }, [companies]);

    useEffect(() => {
        if (initialLoadComplete.current) return;
        if (associateCompanies && associateCompanies.length > 0 && Object.keys(previousFilters || {}).length) {
            if (company && company.value === ((previousFilters || {}).company || {}).value) {
                const _associateCompany = associateCompanies.find((ac: any) => ac.value === ((previousFilters || {}).associate_company || {}).value);
                if (_associateCompany) {
                    setAssociateCompany(_associateCompany);
                }
            }
        }
    }, [associateCompanies]);

    useEffect(() => {
        if (initialLoadComplete.current) return;
        if (locations && locations.length > 0 && Object.keys(previousFilters || {}).length) {
            if (company && company.value === ((previousFilters || {}).company || {}).value &&
                associate_company && associate_company.value === ((previousFilters || {}).associate_company || {}).value) {
                const _location = locations.find((loc: any) => loc.value === ((previousFilters || {}).location || {}).value);
                if (_location) {
                    setLocation(_location);
                }
                initialLoadComplete.current = true;
            }
        }
        if (!Object.keys(previousFilters || {}).length && locations && locations.length > 0) {
            initialLoadComplete.current = true;
        }
    }, [locations]);

    useEffect(() => {
        // Don't call onChange until companies are loaded
        if (!companies || companies.length === 0) {
            return;
        }

        const filters: any = {};
        const filterData: any = {};

        if (company && company.value === "all") {
            const allCompanyIds = companies.map((c: any) => c.value);
            if (allCompanyIds.length > 0) {
                filters.company_id_in = allCompanyIds;
            }
        } else if (company && company.value !== "all") {
            filters.company_id_eq = company.value;
            filterData.company = company;
        }

        if (associate_company && associate_company.value !== "all") {
            filters.associate_company_id_eq = associate_company.value;
            filterData.associate_company = associate_company;
        }

        if (location && location.value !== "all") {
            filters.location_id_eq = location.value;
            filters.state_id = location.state_id;
            filterData.location = location;
        }

        onChange(filters, filterData);
    }, [company, associate_company, location, companies]);

    useEffect(() => {
        if (!isFetching && userCompanies) {
            const companies = userCompanies.map((company: any) => {
                return { value: company.id, label: company.name, company }
            });
            const sorted = sortBy(companies, 'label');
            setCompanies(sorted);
        }
    }, [isFetching]);

    return (
        <>
            <div className="px-2">
                <label className="filter-label"><small>Company</small></label>
                <AuditSelect
                    placeholder='Company'
                    options={[ALL_OPTION, ...companies]}
                    onChange={setCompany}
                    value={company}
                />
            </div>
            <div className="px-2">
                <label className="filter-label"><small>Associate Company</small></label>
                <AuditSelect
                    placeholder='Associate Company'
                    options={associateCompanies.length > 0 ? [ALL_OPTION, ...associateCompanies] : [ALL_OPTION]}
                    onChange={setAssociateCompany}
                    value={associate_company}
                    isDisabled={!company || company.value === "all"}
                />
            </div>
            <div className="px-2">
                <label className="filter-label"><small>Location</small></label>
                <AuditSelect
                    placeholder='Location'
                    options={locations.length > 0 ? [ALL_OPTION, ...locations] : [ALL_OPTION]}
                    onChange={setLocation}
                    value={location}
                    isDisabled={!associate_company || associate_company.value === "all"}
                />
            </div>
        </>
    )
}

export default Location;
